export default __webpack_public_path__ + "d7bb42acc75221910a9bcbbf3303858b.svg";